(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("@bytel/bytel-jwt"), require("lodash/compact"), require("lodash/fromPairs"), require("lodash/isFunction"), require("lodash/map"), require("url-composer"));else if (typeof define === 'function' && define.amd) define(["@bytel/bytel-jwt", "lodash/compact", "lodash/fromPairs", "lodash/isFunction", "lodash/map", "url-composer"], factory);else if (typeof exports === 'object') exports["bytelOAuth"] = factory(require("@bytel/bytel-jwt"), require("lodash/compact"), require("lodash/fromPairs"), require("lodash/isFunction"), require("lodash/map"), require("url-composer"));else root["bytelOAuth"] = factory(root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined]);
})(window, function (__WEBPACK_EXTERNAL_MODULE__bytel_bytel_jwt__, __WEBPACK_EXTERNAL_MODULE_lodash_compact__, __WEBPACK_EXTERNAL_MODULE_lodash_fromPairs__, __WEBPACK_EXTERNAL_MODULE_lodash_isFunction__, __WEBPACK_EXTERNAL_MODULE_lodash_map__, __WEBPACK_EXTERNAL_MODULE_url_composer__) {
  return /******/function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/ // The require function
    /******/
    function __webpack_require__(moduleId) {
      /******/
      /******/ // Check if module is in cache
      /******/if (installedModules[moduleId]) {
        /******/return installedModules[moduleId].exports;
        /******/
      }
      /******/ // Create a new module (and put it into the cache)
      /******/
      var module = installedModules[moduleId] = {
        /******/i: moduleId,
        /******/l: false,
        /******/exports: {}
        /******/
      };
      /******/
      /******/ // Execute the module function
      /******/
      modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
      /******/
      /******/ // Flag the module as loaded
      /******/
      module.l = true;
      /******/
      /******/ // Return the exports of the module
      /******/
      return module.exports;
      /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/
    __webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/
    __webpack_require__.c = installedModules;
    /******/
    /******/ // define getter function for harmony exports
    /******/
    __webpack_require__.d = function (exports, name, getter) {
      /******/if (!__webpack_require__.o(exports, name)) {
        /******/Object.defineProperty(exports, name, {
          enumerable: true,
          get: getter
        });
        /******/
      }
      /******/
    };
    /******/
    /******/ // define __esModule on exports
    /******/
    __webpack_require__.r = function (exports) {
      /******/if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
        /******/Object.defineProperty(exports, Symbol.toStringTag, {
          value: 'Module'
        });
        /******/
      }
      /******/
      Object.defineProperty(exports, '__esModule', {
        value: true
      });
      /******/
    };
    /******/
    /******/ // create a fake namespace object
    /******/ // mode & 1: value is a module id, require it
    /******/ // mode & 2: merge all properties of value into the ns
    /******/ // mode & 4: return value when already ns object
    /******/ // mode & 8|1: behave like require
    /******/
    __webpack_require__.t = function (value, mode) {
      /******/if (mode & 1) value = __webpack_require__(value);
      /******/
      if (mode & 8) return value;
      /******/
      if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
      /******/
      var ns = Object.create(null);
      /******/
      __webpack_require__.r(ns);
      /******/
      Object.defineProperty(ns, 'default', {
        enumerable: true,
        value: value
      });
      /******/
      if (mode & 2 && typeof value != 'string') for (var key in value) __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
      /******/
      return ns;
      /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/
    __webpack_require__.n = function (module) {
      /******/var getter = module && module.__esModule ? /******/function getDefault() {
        return module['default'];
      } : /******/function getModuleExports() {
        return module;
      };
      /******/
      __webpack_require__.d(getter, 'a', getter);
      /******/
      return getter;
      /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/
    __webpack_require__.o = function (object, property) {
      return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/
    __webpack_require__.p = "";
    /******/
    /******/
    /******/ // Load entry module and return exports
    /******/
    return __webpack_require__(__webpack_require__.s = "./src/index.js");
    /******/
  }
  /************************************************************************/
  /******/({
    /***/"./src/cookie.js": (
    /*!***********************!*\
      !*** ./src/cookie.js ***!
      \***********************/
    /*! exports provided: readCookie, default */
    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "readCookie", function () {
        return readCookie;
      });
      function readCookie(name, c, C, i) {
        c = document.cookie.split('; ');
        for (i = c.length - 1; i >= 0; i--) {
          C = c[i].split('=');
          if (C[0] === name) return C[1];
        }
        return null;
      }
      /* harmony default export */
      __webpack_exports__["default"] = {
        read: readCookie
      };

      /***/
    }),
    /***/"./src/dom.js": (
    /*!********************!*\
      !*** ./src/dom.js ***!
      \********************/
    /*! exports provided: default */
    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony import */
      var lodash_isFunction__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash/isFunction */"lodash/isFunction");
      /* harmony import */
      var lodash_isFunction__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_isFunction__WEBPACK_IMPORTED_MODULE_0__);
      function injectIframe() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var body = document.querySelector('body');
        var iframe = document.createElement('iframe');
        var src = options.src,
          onload = options.onload;
        iframe.src = src;
        iframe.sandbox = 'allow-scripts allow-same-origin';
        iframe.scrolling = 'no';
        iframe.frameborder = 0;
        iframe.style.display = 'none';
        iframe.onload = function (e) {
          if (lodash_isFunction__WEBPACK_IMPORTED_MODULE_0___default()(onload)) onload(e);
        };
        body.appendChild(iframe);
        return iframe;
      }
      function remove(node, from) {
        from = from || document.querySelector('body');
        return from.removeChild(node);
      }

      /* harmony default export */
      __webpack_exports__["default"] = {
        injectIframe: injectIframe,
        remove: remove
      };

      /***/
    }),
    /***/"./src/index.js": (
    /*!**********************!*\
      !*** ./src/index.js ***!
      \**********************/
    /*! exports provided: request, connect, decodeToken, default */
    /***/
    function (module, __webpack_exports__, __webpack_require__) {
      "use strict";

      __webpack_require__.r(__webpack_exports__);
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "request", function () {
        return request;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "connect", function () {
        return connect;
      });
      /* harmony export (binding) */
      __webpack_require__.d(__webpack_exports__, "decodeToken", function () {
        return decodeToken;
      });
      /* harmony import */
      var lodash_map__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash/map */"lodash/map");
      /* harmony import */
      var lodash_map__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_map__WEBPACK_IMPORTED_MODULE_0__);
      /* harmony import */
      var lodash_compact__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! lodash/compact */"lodash/compact");
      /* harmony import */
      var lodash_compact__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_compact__WEBPACK_IMPORTED_MODULE_1__);
      /* harmony import */
      var lodash_fromPairs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! lodash/fromPairs */"lodash/fromPairs");
      /* harmony import */
      var lodash_fromPairs__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_fromPairs__WEBPACK_IMPORTED_MODULE_2__);
      /* harmony import */
      var _bytel_bytel_jwt__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @bytel/bytel-jwt */"@bytel/bytel-jwt");
      /* harmony import */
      var _bytel_bytel_jwt__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_bytel_bytel_jwt__WEBPACK_IMPORTED_MODULE_3__);
      /* harmony import */
      var url_composer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! url-composer */"url-composer");
      /* harmony import */
      var url_composer__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(url_composer__WEBPACK_IMPORTED_MODULE_4__);
      /* harmony import */
      var _dom__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./dom */"./src/dom.js");
      /* harmony import */
      var _cookie__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./cookie */"./src/cookie.js");
      var JWS = _bytel_bytel_jwt__WEBPACK_IMPORTED_MODULE_3___default.a.KJUR.jws.JWS;
      function request() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return new Promise(function (resolve, reject) {
          var url = options.url,
            clientId = options.clientId,
            callback = options.callback; // Listen to postMessage events

          window.addEventListener('message', messageHandler, false);
          var ssoActive = _cookie__WEBPACK_IMPORTED_MODULE_6__["default"].read('SSO_ACTIVE');
          if (!ssoActive) return reject(new Error('[bytel-oauth] SSO_ACTIVE cookie is missing'));
          if (!url || !clientId || !callback) return reject(new Error('[bytel-oauth] Missing OAuth parameters')); // Build oauth url

          var oauthUrlOptions = {
            host: url,
            path: '/authorize',
            query: {
              client_id: clientId,
              response_type: 'id_token token',
              redirect_uri: callback,
              prompt: 'none'
            }
          }; // Create iframe pointing to oauth url

          var oauthIframe = _dom__WEBPACK_IMPORTED_MODULE_5__["default"].injectIframe({
            src: url_composer__WEBPACK_IMPORTED_MODULE_4___default.a.build(oauthUrlOptions)
          }); // -----------------
          // Helper methods
          // -----------------

          function messageHandler(e) {
            // Only listen to messages coming from our iframe
            if (!oauthIframe || e.source !== oauthIframe.contentWindow) return;
            var data = e.data || ''; // Remove first character from string

            data = parseQuery(data.slice(1));
            if (!data.access_token && !data.id_token) return reject(new Error('[bytel-oauth] Not connected')); // Parse JWT

            var payload = decodeToken(data.id_token); // When everything is ok remove iframe from dom

            _dom__WEBPACK_IMPORTED_MODULE_5__["default"].remove(oauthIframe); // Stop listening to postMessage events

            window.removeEventListener('message', messageHandler, false); // Resolve Promise with OAuth data

            resolve({
              payload: payload,
              accessToken: data.access_token
            });
          }
        })["catch"](function (error) {
          throw error;
        });
      }
      function connect(options) {
        if (options.accessToken) {
          var payload;
          if (options.idToken) payload = decodeToken(options.idToken);else if (options.id_personne && options.user_type) {
            var id_personne = options.id_personne,
              user_type = options.user_type;
            payload = {
              id_personne: id_personne,
              user_type: user_type
            };
          }
          if (!payload) return Promise.reject(new Error('Could not parse JWT payload'));
          return Promise.resolve({
            payload: payload,
            accessToken: options.accessToken
          });
        }
        return request(options);
      }
      function decodeToken(token) {
        var payload;
        try {
          var jws = new JWS();
          jws.parseJWS(token);
          payload = JSON.parse(jws.parsedJWS.payloadS);
        } catch (e) {
          throw new Error('[bytel-oauth] Could not parse JWT payload');
        }
        return payload;
      }
      function parseQuery() {
        var queryString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        return lodash_fromPairs__WEBPACK_IMPORTED_MODULE_2___default()(lodash_map__WEBPACK_IMPORTED_MODULE_0___default()(lodash_compact__WEBPACK_IMPORTED_MODULE_1___default()(queryString.split('&')), function (group) {
          return lodash_compact__WEBPACK_IMPORTED_MODULE_1___default()(group.split('='));
        }));
      }

      /* harmony default export */
      __webpack_exports__["default"] = {
        request: request,
        connect: connect,
        decodeToken: decodeToken
      };

      /***/
    }),
    /***/"@bytel/bytel-jwt": (
    /*!*********************************************************************************************************************************!*\
      !*** external {"umd":"@bytel/bytel-jwt","amd":"@bytel/bytel-jwt","commonjs":"@bytel/bytel-jwt","commonjs2":"@bytel/bytel-jwt"} ***!
      \*********************************************************************************************************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE__bytel_bytel_jwt__;

      /***/
    }),
    /***/"lodash/compact": (
    /*!*************************************************************************************************************************!*\
      !*** external {"umd":"lodash/compact","amd":"lodash/compact","commonjs":"lodash/compact","commonjs2":"lodash/compact"} ***!
      \*************************************************************************************************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_compact__;

      /***/
    }),
    /***/"lodash/fromPairs": (
    /*!*********************************************************************************************************************************!*\
      !*** external {"umd":"lodash/fromPairs","amd":"lodash/fromPairs","commonjs":"lodash/fromPairs","commonjs2":"lodash/fromPairs"} ***!
      \*********************************************************************************************************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_fromPairs__;

      /***/
    }),
    /***/"lodash/isFunction": (
    /*!*************************************************************************************************************************************!*\
      !*** external {"umd":"lodash/isFunction","amd":"lodash/isFunction","commonjs":"lodash/isFunction","commonjs2":"lodash/isFunction"} ***!
      \*************************************************************************************************************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_isFunction__;

      /***/
    }),
    /***/"lodash/map": (
    /*!*********************************************************************************************************!*\
      !*** external {"umd":"lodash/map","amd":"lodash/map","commonjs":"lodash/map","commonjs2":"lodash/map"} ***!
      \*********************************************************************************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_lodash_map__;

      /***/
    }),
    /***/"url-composer": (
    /*!*****************************************************************************************************************!*\
      !*** external {"umd":"url-composer","amd":"url-composer","commonjs":"url-composer","commonjs2":"url-composer"} ***!
      \*****************************************************************************************************************/
    /*! no static exports found */
    /***/
    function (module, exports) {
      module.exports = __WEBPACK_EXTERNAL_MODULE_url_composer__;

      /***/
    })

    /******/
  });
});
